<template>
  <div>
    <!-- Modale cartella -->
    <wg-modal
      v-if="openFolderModal"
      :portal="true"
      :width="windowWidth > 700 ? '400px' : '90%'"
      @closeModal="openFolderModal = false"
    >
      <div class="com-anm22-app-text-xl" slot="header">
        {{
          !folderModalEditMode
            ? $anm22.strLang(lang, "New folder", "Nuova cartella")
            : $anm22.strLang(lang, "Edit folder", "Modifica cartella")
        }}
      </div>
      <div slot="body">
        <div class="wg-col wg-xs-12">
          <input
            :disabled="!canEdit"
            class="anm22-calendar-input-text"
            style="max-width: 100%"
            type="text"
            v-model="modalFolder.name"
            :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
          />
        </div>
        <div class="wg-col wg-xs-12">
          <select v-model="modalFolder.folder" class="com-anm22-app-select">
            <option :value="null">
              {{ $anm22.strLang(lang, "Main folder", "Cartella principale") }}
            </option>
            <option
              v-for="(item, index) in foldersList(modalFolder)"
              :key="'folder-list-' + index"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class="wg-col wg-xs-12 action-btns">
          <div
            v-if="!folderModalEditMode"
            class="action-btn"
            @click="saveFolder"
          >
            {{ $anm22.strLang(lang, "Add", "Crea") }}
          </div>
          <div
            v-if="folderModalEditMode"
            class="action-btn"
            @click="saveFolder"
          >
            {{ $anm22.strLang(lang, "Save", "Salva") }}
          </div>
          <div
            v-if="folderModalEditMode"
            @click="deleteFolder()"
            class="action-btn red"
          >
            {{ $anm22.strLang(lang, "Delete", "Elimina") }}
          </div>
        </div>
      </div>
    </wg-modal>
    <!-- Modale file -->
    <wg-modal
      v-if="openFileModal"
      :portal="true"
      :width="windowWidth > 700 ? '400px' : '90%'"
      @closeModal="openFileModal = false"
    >
      <div class="com-anm22-app-text-xl" slot="header">
        {{
          !fileModalEditMode
            ? $anm22.strLang(lang, "New file", "Nuovo file")
            : $anm22.strLang(lang, "Edit file", "Modifica file")
        }}
      </div>
      <div slot="body">
        <!-- Select tipo di evento in caso di nuovo evento -->
        <div
          class="wg-row"
          style="padding: 0 0 10px 0"
          v-if="!fileModalEditMode"
        >
          <div
            v-for="(type, i) in fileTypes()"
            :key="'type-' + i"
            :class="[
              'type-select-elem',
              type.id === modalFile.fileType ? 'selected' : '',
            ]"
            @click="() => (modalFile.fileType = type.id)"
          >
            {{ type.label }}
          </div>
        </div>
        <div class="wg-col wg-xs-12">
          <input
            :disabled="!canEdit"
            class="anm22-calendar-input-text"
            style="max-width: 100%"
            type="text"
            v-model="modalFile.name"
            :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
          />
        </div>
        <div class="wg-col wg-xs-12">
          <select v-model="modalFile.folder" class="com-anm22-app-select">
            <option :value="null">
              {{ $anm22.strLang(lang, "Main folder", "Cartella principale") }}
            </option>
            <option
              v-for="(item, index) in foldersList()"
              :key="'folder-list-' + index"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class="wg-col wg-xs-12">
          <input
            :disabled="!canEdit"
            class="anm22-calendar-input-text"
            style="max-width: 100%"
            type="text"
            v-model="modalFile.description"
            :placeholder="$anm22.strLang(lang, 'Description', 'Descrizione')"
          />
        </div>
        <div v-if="modalFile.fileType == 'link'" class="wg-col wg-xs-12">
          <input
            :disabled="!canEdit"
            class="anm22-calendar-input-text"
            style="max-width: 100%"
            type="text"
            v-model="modalFile.link"
            :placeholder="$anm22.strLang(lang, 'Link', 'Link')"
          />
        </div>
        <div v-if="!fileModalEditMode" class="wg-col wg-xs-12">
          <select v-model="sendNotification" class="com-anm22-app-select">
            <option :value="false">
              {{ $anm22.strLang(lang, "No notification", "Nessuna notifica") }}
            </option>
            <option :value="true">
              {{ $anm22.strLang(lang, "Send notification", "Invia notifica") }}
            </option>
          </select>
        </div>
        <anm22-file-uploader
          v-if="
            modalFile.fileType == 'file' &&
            !fileModalEditMode &&
            !modalFile.file
          "
          :uploadUrl="'events/file-upload?work=' + event.work"
          :allowedExtensions="[
            'xls',
            'xlsx',
            'pdf',
            'doc',
            'docx',
            'ps',
            'ai',
            'eps',
            'jpg',
            'jpeg',
            'png',
            'svg',
            'dwg',
          ]"
          :onSuccess="addFile"
        ></anm22-file-uploader>
        <input
          v-if="modalFile.fileType == 'file' && modalFile.file"
          :disabled="true"
          class="anm22-calendar-input-text"
          style="max-width: 100%"
          type="text"
          v-model="modalFile.file"
          :placeholder="$anm22.strLang(lang, 'File URL', 'URL file')"
        />
        <div class="wg-col wg-xs-12 action-btns">
          <div v-if="!fileModalEditMode" class="action-btn" @click="saveFile">
            {{ $anm22.strLang(lang, "Add", "Crea") }}
          </div>
          <div v-if="fileModalEditMode" class="action-btn" @click="saveFile">
            {{ $anm22.strLang(lang, "Save", "Salva") }}
          </div>
          <div
            v-if="fileModalEditMode"
            @click="deleteFile()"
            class="action-btn red"
          >
            {{ $anm22.strLang(lang, "Delete", "Elimina") }}
          </div>
        </div>
      </div>
    </wg-modal>
    <!-- Titolo lista -->
    <div class="file-archive-title">
      <img :src="$anm22.icons.getWorldIcon('folderMaterial')" class="label-ic" />
      <div>
        {{ $anm22.strLang(lang, "File archive", "Archivio file") }}
      </div>
    </div>
    <!-- Lista file -->
    <div class="file-list">
      <div
        v-for="(item, index) in folderFiles()"
        :key="'file-item-' + index"
        class="wg-row file-item"
      >
        <div
          v-if="item.type == 'folder'"
          class="wg-col wg-xs-12 folder"
          @click="openEditFolderModal(item)"
        >
          <img class="file-icon" :src="$anm22.icons.getWorldIcon('folder')" />
          <div class="file-label">{{ item.name ? item.name : "Folder" }}</div>
        </div>
        <template v-if="item.type == 'folder'">
          <div
            v-for="(subitem, subindex) in folderFiles(item.id)"
            :key="'file-item-' + subindex"
            class="wg-row file-item"
          >
            <!-- Folder Livello 1 -->
            <div
              v-if="subitem.type == 'folder'"
              class="wg-col wg-xs-12 folder"
              @click="openEditFolderModal(subitem)"
            >
              <img
                class="file-icon"
                :src="$anm22.icons.getWorldIcon('folder')"
              />
              <div class="file-label">
                {{ subitem.name ? subitem.name : "Folder" }}
              </div>
            </div>
            <template v-if="subitem.type == 'folder'">
              <div
                v-for="(subsubitem, subsubindex) in folderFiles(subitem.id)"
                :key="'file-item-' + subsubindex"
                class="wg-row file-item"
              >
                <!-- File livello 2 -->
                <div
                  v-if="subsubitem.type == 'file'"
                  class="wg-col wg-xs-12 file"
                  @click="openEditFileModal(subsubitem)"
                >
                  <img class="file-icon" :src="getFileIcon(subsubitem)" />
                  <div class="file-label">
                    {{ subsubitem.name ? subsubitem.name : "File" }}
                  </div>
                </div>
              </div>
            </template>
            <!-- File livello 1 -->
            <div
              v-if="subitem.type == 'file'"
              class="wg-col wg-xs-12 file"
              @click="openEditFileModal(subitem)"
            >
              <img class="file-icon" :src="getFileIcon(subitem)" />
              <div class="file-label">
                {{ subitem.name ? subitem.name : "File" }}
              </div>
            </div>
          </div>
        </template>
        <!-- File livello 0 -->
        <div
          v-if="item.type == 'file'"
          class="wg-col wg-xs-12 file"
          @click="openEditFileModal(item)"
        >
          <img class="file-icon" :src="getFileIcon(item)" />
          <div class="file-label">{{ item.name ? item.name : "File" }}</div>
        </div>
      </div>
      <div class="wg-row file-item">
        <div class="wg-col wg-xs-12 new-file" @click="openNewFileModal()">
          <div class="file-label">
            + {{ $anm22.strLang(lang, "New file", "Nuovo file") }}
          </div>
        </div>
      </div>
      <div class="wg-row file-item">
        <div class="wg-col wg-xs-12 new-folder" @click="openNewFolderModal()">
          <div class="file-label">
            + {{ $anm22.strLang(lang, "New folder", "Nuova cartella") }}
          </div>
        </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height: 10px"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Anm22FileUploader from "../../../../../world/spa/components/Anm22FileUploader.vue";
import WorldDatePicker from "../../../../../world/spa/components/WorldDatePicker.vue";

export default {
  props: {
    eventRef: Object,
    showSaved: Boolean,
  },
  components: {
    Anm22FileUploader,
    WorldDatePicker,
  },
  data() {
    return {
      openFolderModal: false,
      openFileModal: false,
      event: { ...this.eventRef },
      sd: "",
      sdInput: "",
      st: "",
      stInput: "",
      modalFolder: null,
      folderModalEditMode: false,
      modalFile: null,
      fileModalEditMode: false,
      sendNotification: false,
    };
  },
  computed: {
    ...mapState({
      windowWidth: (state) => state.windowWidth,
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
    }),
    works() {
      return this.$store.getters["works/getAll"];
    },
    canEdit() {
      const invites = this.$store.getters["invites/getByEvent"](
        this.event.idWorldEvent
      );
      return (
        !this.event.idWorldEvent ||
        invites.find(
          (i) => i.user === this.user.idWorldUser && i.permission == 1
        ) !== -1
      );
    },
    startDate: {
      get() {
        return this.sd;
      },
      set: function (newDate) {
        this.sd = newDate;
      },
    },
    startTime: {
      get() {
        return this.st;
      },
      set: _.debounce(function (newTime) {
        this.st = newTime;
      }, 1000),
    },
    startDateInput: {
      get() {
        return this.sd;
      },
      set: function (newDate) {
        // Controllo che sia nel formato giusto
        this.sdInput = this.$anm22.parseInputDate(newDate);
        // debounced
        this.startDate = this.sdInput;
      },
    },
    startTimeInput: {
      get() {
        return this.st;
      },
      set: function (newTime) {
        // Controllo che sia nel formato giusto
        this.stInput = this.$anm22.parseInputTime(newTime);
        this.startTime = this.stInput;
      },
    },
  },
  methods: {
    setDate(newDate) {
      this.sdInput = this.$anm22.parseInputDate(newDate);
      this.startDate = this.sdInput;
      this.openPicker = false;
    },
    save() {
      this.sd = this.sdInput || this.sd;
      this.st = this.stInput || this.st;
      // Collego timezone e date
      this.event.startTimestamp = this.$moment
        .tz(this.sd + " " + this.st, this.event.timezone)
        .unix();
      this.event.endTimestamp = this.$moment
        .tz(this.sd + " " + this.st, this.event.timezone)
        .unix();
      this.$emit("save", this.event);
    },
    eventFiles() {
      if (this.event.jsonData && this.event.jsonData.files) {
        return this.event.jsonData.files;
      } else {
        return [];
      }
    },
    folderFiles(folderId) {
      // Cartella principale
      if (!folderId) {
        return this.eventFiles().filter(
          (item) => !item.folder || item.folder == ""
        );
      } else {
        return this.eventFiles().filter(
          (item) => item.folder && item.folder == folderId
        );
      }
    },
    foldersList(folderToExclude) {
      let foldersList = this.eventFiles().filter(
        (item) => item.type == "folder"
      );
      if (folderToExclude) {
        foldersList = foldersList.filter(
          (item) => item.id != folderToExclude.id
        );
      }
      return foldersList;
    },
    openNewFolderModal() {
      this.modalFolder = {
        id: this.event.idWorldEvent + "-folder-" + this.$moment().unix(),
        name: this.newFolderName,
        type: "folder",
        folder: null,
        ts: this.$moment().unix(),
      };
      this.folderModalEditMode = false;
      this.openFolderModal = true;
    },
    openEditFolderModal(folder) {
      this.modalFolder = folder;
      this.folderModalEditMode = true;
      this.openFolderModal = true;
    },
    closeFolderModal() {
      this.openFolderModal = false;
    },
    saveFolder() {
      if (!this.event.jsonData) {
        this.event.jsonData = {};
      }
      if (!this.event.jsonData.files) {
        this.event.jsonData.files = [];
      }
      const folder = { ...this.modalFolder };
      if (this.folderModalEditMode) {
        const target = this.event.jsonData.files.find(
          (obj) => obj.id === folder.id
        );
        Object.assign(target, folder);
      } else {
        this.event.jsonData.files.push(folder);
      }
      this.$emit("save", this.event);
      this.closeFolderModal();
    },
    deleteFolder() {
      const elementId = this.modalFolder.id;
      let filesArrayId = null;
      this.event.jsonData.files.forEach((item, key) => {
        if (item.id == elementId) {
          filesArrayId = key;
        }
      });
      this.event.jsonData.files.splice(filesArrayId, 1);
      this.$emit("save", this.event);
      this.openFolderModal = false;
    },
    openNewFileModal() {
      this.modalFile = {
        id: this.event.idWorldEvent + "-file-" + this.$moment().unix(),
        name: "",
        type: "file",
        fileType: "file",
        link: "",
        description: "",
        folder: null,
        file: null,
        ext: null,
        ts: this.$moment().unix(),
      };
      this.fileModalEditMode = false;
      this.sendNotification = false;
      this.openFileModal = true;
    },
    openEditFileModal(file) {
      this.modalFile = file;
      this.fileModalEditMode = true;
      this.openFileModal = true;
    },
    closeNewFileModal() {
      this.openFileModal = false;
    },
    saveFile(data, closeModal = true) {
      if (!this.event.jsonData) {
        this.event.jsonData = {};
      }
      if (!this.event.jsonData.files) {
        this.event.jsonData.files = [];
      }
      const file = { ...this.modalFile };
      if (this.fileModalEditMode) {
        const target = this.event.jsonData.files.find(
          (obj) => obj.id === file.id
        );
        Object.assign(target, file);
      } else {
        this.event.jsonData.files.push(file);
      }
      this.$emit("save", this.event);

      if (this.sendNotification) {
        this.sendFileNotification();
      }

      this.openFileModal = !closeModal;
    },
    addFile(data) {
      // Aggiungo url file
      if (data && data.url) {
        this.modalFile.file = data.url;
        this.modalFile.ext = data.fileExt;
        if (!this.modalFile.name) {
          this.modalFile.name = data.fileName;
        }
      }
    },
    deleteFile() {
      const elementId = this.modalFile.id;
      let filesArrayId = null;
      this.event.jsonData.files.forEach((item, key) => {
        if (item.id == elementId) {
          filesArrayId = key;
        }
      });
      this.event.jsonData.files.splice(filesArrayId, 1);
      this.$emit("save", this.event);
      this.openFileModal = false;
    },
    // Tipologie file
    fileTypes() {
      var types = [
        {
          id: "file",
          label: this.$anm22.strLang(this.lang, "File", "File"),
        },
        {
          id: "link",
          label: this.$anm22.strLang(this.lang, "Link", "Link"),
        },
      ];
      return types;
    },
    getFileIcon(item) {
      let iconUrl = this.$anm22.icons.getWorldIcon("fileDefault");
      if (item.fileType) {
        switch (item.fileType) {
          case "link":
            iconUrl = this.$anm22.icons.getWorldIcon("link");
            break;
        }
      }
      return iconUrl;
    },
    sendFileNotification() {
      this.$http
        .post(
          "events/send-file-notification",
          {
            title: this.event.name,
            description: "Nuovo documento disponibile: " + this.modalFile.name,
          },
          {
            withCredentials: true,
          }
        )
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    this.sd = this.sdInput = this.$moment
      .unix(this.event.startTimestamp)
      .tz(this.event.timezone)
      .format("YYYY-MM-DD");
    this.st = this.stInput = this.$moment
      .unix(this.event.startTimestamp)
      .tz(this.event.timezone)
      .format("HH:mm");
  },
};
</script>

<style lang="scss" scoped>
.file-archive-title {
  display: flex;
  align-items: center;
  border-radius: 6px;
  padding: 6px 0 12px 0;
  font-weight: 500;

  .label-ic {
    width: 20px;
    height: 20px;
    margin-right: 6px;
  }
}
.cont-tick {
  display: inline-block;
  height: auto;
  margin-left: 11px;
  width: 24px;
}
.icon-div {
  border-radius: 30px;
  width: 50px;
  height: 50px;
  border: 1px solid #9999;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  padding: 5px;
  margin: 5px 10px;
  cursor: pointer;
  &:hover {
    border: none;
    background-color: #eee;
  }
}
.input-date-picker-label {
  width: 100%;
  max-width: 300px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 4px;
  display: block;
  box-shadow: none;
  background-color: #eee;
  border: 1px solid #eee;
  height: 36px;
  font-size: 12px;
  cursor: pointer;
}
.icon-div.desc-box {
  border: none;
  width: 40px;
  height: 40px;
  padding: 2px;
  background-color: #eee;
  &:hover {
    background-color: #ddd;
  }
}

.file-list {
  .file-item {
    padding: 8px 16px;
    border-bottom: 1px solid #ccc;

    &:last-child {
      border-bottom: 0;
    }

    & > .folder {
      padding-bottom: 8px;
    }

    & > div {
      cursor: pointer;
    }

    .file-icon {
      display: inline-block;
      vertical-align: middle;
      opacity: 0.6;
      width: 24px;
      margin-right: 16px;
    }
    .file-label {
      display: inline-block;
      vertical-align: middle;
      font-size: 14px;
      max-width: calc(100% - 40px);
    }
  }
}

.type-select-elem {
  padding: 5px;
  margin-right: 5px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background-color: #fff;
  cursor: pointer;
  &:hover {
    border: 1px solid #0aabf4;
  }
  &.selected {
    border: 2px solid #0aabf4;
  }
}

.action-btns {
  text-align: right;

  .action-btn {
    font-weight: 700;
    margin: 8px 0 0 16px;
    display: inline-block;
    vertical-align: middle;
    font-size: 16px;
    cursor: pointer;

    &.green {
      color: green;
    }
    &.red {
      color: red;
    }
  }
}
</style>
